import styled from 'styled-components';
import * as variables from './../../assets/css/variables';

export const Container = styled.article`
    box-shadow: 0 0.1rem 0.5rem 0 rgba(0, 0, 0, .3);
    padding: 1.0757142857142858rem;
    border-radius: .4rem;
    display: flex;
    flex-direction: column;
    margin-bottom: 2rem;
    
    .div__container {
        display: flex;
        
        .div__left {
            width: 5.237857142857143rem;
            margin-right: 1.34rem;
            
            img {
                width: 5.237857142857143rem;
            }
        }
        
        .div__right {
            flex-shrink: 0;
            flex-grow: 1;
            
            h1 {
                font-size: 1.4285714285714286rem;
                margin-bottom: 0.7142857142857143rem;
                padding: 0;
            }
            
            p {
                font-size: 1.1428571428571428rem;
                margin-bottom: 0.72rem;
            }
        }
    }
    
    .div__footer {
        margin-top: 0.3892857142857143rem;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-end;
        
        a {
            text-decoration: underline;
            font-size: 1rem;
            color: #D3D3D3;
        }
    }
    
    @media (max-width: ${variables.TABLET}) {
        margin-bottom: 0;
        
        .div__container {
            .div__left {
                width: 2.87rem;
                
                img {
                    width: 2.87rem;
                }
            }
            
            .div__right {
                 h1 {
                    font-size: 1.1428571428571428rem;
                 }
                 
                  p {
                    font-size: 1rem;
                  }
            }
        }
    }
`;